import { httpRequest } from "@/axios/axios-api";

export default {
  data() {
    return {
      chapterContent: { name: "", picList: [] },
      majorType: 0,
      category: 2,
      hasAccess: true,
      accessMessage: "",
      accessCode: null
    };
  },
  computed: {
    categoryTitle() {
      const map = {
        0: "专家讲义",
        1: "教材",
        2: "教学大纲"
      };
      return map[this.category] || "课程";
    }
  },
  created: function() {
    this.syncRouteFilters();
    // 加载课程列表
    this.loadCourseList();
  },
  watch: {
    $route() {
      this.syncRouteFilters();
      this.loadCourseList();
    }
  },
  methods: {
    syncRouteFilters() {
      const routeMajorType = Number(this.$route.query.majorType);
      this.majorType = Number.isFinite(routeMajorType) ? routeMajorType : 0;
      const routeCategory = Number(this.$route.query.category);
      this.category = [0, 1, 2].includes(routeCategory) ? routeCategory : 2;
    },
    goHome() {
      this.$router.push("/home");
    },
    goStudyPage() {
      this.$router.push("/studyPage");
    },
    goCourseList() {
      this.$router.push({
        path: "/courseList",
        query: {
          majorType: this.majorType,
          category: this.category
        }
      });
    },
    goEnrollPage() {
      const pathMap = {
        0: "/examsList",
        1: "/examsListzx",
        2: "/examsListzt",
        3: "/examsListsz"
      };
      const path = pathMap[this.majorType] || "/home";
      this.$router.push({
        path,
        query: {
          majorType: this.majorType
        }
      });
    },
    async loadCourseList() {
      const rtcId = Number(this.$route.query.rtcId);
      if (!Number.isFinite(rtcId) || rtcId <= 0) {
        this.$message.warning("课程参数异常");
        this.hasAccess = false;
        this.accessMessage = "课程参数异常";
        this.accessCode = null;
        this.chapterContent = { name: "", picList: [] };
        return;
      }

      const loadingInstance = this.$loading({ text: "加载中" });
      const res = await httpRequest("/app/course/rich/" + rtcId, "get", null);
      if (res !== null && res !== undefined && res.code === 200) {
        const detail = res.data || {};
        const detailMajorType = Number(detail.majorType);
        if (Number.isFinite(detailMajorType) && detailMajorType >= 0) {
          this.majorType = detailMajorType;
        }
        const detailCategory = Number(detail.category);
        if ([0, 1, 2].includes(detailCategory)) {
          this.category = detailCategory;
        }
        this.hasAccess = true;
        this.accessMessage = "";
        this.accessCode = null;
        this.chapterContent = detail;
      } else if (
        res !== null &&
        res !== undefined &&
        Number(res.code) === 3001
      ) {
        this.hasAccess = false;
        this.accessMessage = res.message || "当前课程已加锁";
        this.accessCode = Number(res.code);
        this.chapterContent = { name: "", picList: [] };
      } else {
        this.hasAccess = false;
        this.accessMessage = (res && res.message) || "课程加载失败，请稍后重试";
        this.accessCode = res && res.code ? Number(res.code) : null;
        this.chapterContent = { name: "", picList: [] };
      }
      loadingInstance.close();
    },
    go2CourseContentPage(rtcId) {
      this.$router.push({
        path: "/courseContent",
        query: {
          rtcId: rtcId,
          majorType: this.majorType,
          category: this.category
        }
      });
    }
  }
};
